import type { NavigateFunction } from 'react-router-dom';
import type { AppNotification } from '../api/notificationsApi';
import { parseNotificationData } from './notificationDisplay';

export interface NotificationActionHandlers {
  navigate: NavigateFunction;
  openHtmlDocument: (title: string, htmlContent: string) => void;
  openTextDetail: (title: string, message: string) => void;
}

export async function handleNotificationAction(
  notification: AppNotification,
  handlers: NotificationActionHandlers,
): Promise<void> {
  const type = notification.type || 'GENERAL';
  const title = notification.title || 'Chi tiết thông báo';
  const message = notification.message || '';
  const payload = parseNotificationData(notification.data);

  const htmlContent = payload.htmlContent;
  if (typeof htmlContent === 'string' && htmlContent.trim()) {
    handlers.openHtmlDocument(title, htmlContent);
    return;
  }

  const str = (key: string) => {
    const v = payload[key];
    return typeof v === 'string' && v.trim() ? v : undefined;
  };

  switch (type) {
    case 'CHAT_MESSAGE': {
      const chatId = str('chatId');
      if (chatId) {
        handlers.navigate(`/chat/${chatId}`);
      } else {
        handlers.navigate('/chat');
      }
      return;
    }
    case 'BOOKING_CONFIRMATION':
    case 'BOOKING_CANCELLATION':
      handlers.navigate('/building-utility-bookings');
      return;
    case 'CONSTRUCTION_REGISTRATION':
    case 'CONSTRUCTION_CONFIRMATION':
    case 'CONSTRUCTION_CANCELLATION':
    case 'CONSTRUCTION_START':
    case 'CONSTRUCTION_COMPLETION':
    case 'CONSTRUCTION_DEPOSIT':
    case 'CONSTRUCTION_DEPOSIT_REFUND': {
      const registrationId = str('registrationId');
      if (registrationId) {
        handlers.navigate(`/building-services/construction/${registrationId}/edit`);
      } else {
        handlers.navigate('/building-services/construction');
      }
      return;
    }
    case 'FEE_NOTIFICATION':
      handlers.navigate('/export-pdf-service-fees');
      return;
    case 'PAYMENT_CONFIRMATION': {
      const billId = str('billId');
      if (billId) {
        handlers.navigate(`/bills/${billId}/invoice`);
      } else {
        handlers.navigate('/payment');
      }
      return;
    }
    case 'TASK_ASSIGNMENT':
    case 'TASK_UPDATE': {
      const taskId = str('taskId');
      if (taskId) {
        handlers.navigate(`/tasks/${taskId}/details`);
      } else {
        handlers.navigate('/tasks');
      }
      return;
    }
    case 'FEEDBACK_RESPONSE': {
      const feedbackId = str('feedbackId');
      if (feedbackId) {
        handlers.navigate(`/feedbacks/${feedbackId}`);
      } else {
        handlers.navigate('/feedbacks');
      }
      return;
    }
    default:
      handlers.openTextDetail(title, message);
  }
}
